export default "__VITE_ASSET__DCowScwV__"